import React, { useState } from "react";
import { Box } from "@mui/material";
import { C, F, S, trans } from "../tokens";

const Accordion = ({ num, title, content }) => {
  const [active, setActive] = useState(false);

  return (
    <Box
      sx={{
        background: C.surface,
        borderRadius: "12px",
        border: active ? "1px solid transparent" : `1px solid ${C.border}`,
        overflow: "hidden",
        boxShadow: active ? S.md : "none",
        transition: `box-shadow ${trans}`,
      }}
    >
      <Box
        component="button"
        type="button"
        aria-expanded={active}
        onClick={() => setActive((a) => !a)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          padding: { xs: "1rem 1.1rem", md: "1.2rem 1.5rem" },
          cursor: "pointer",
          gap: "1rem",
          fontSize: ".9rem",
          fontWeight: 500,
          color: active ? C.accent : C.text,
          background: "none",
          border: "none",
          textAlign: "left",
          transition: `color ${trans}`,
          userSelect: "none",
          "&:hover": { color: C.accent },
        }}
      >
        {num && (
          <Box
            component="span"
            sx={{ fontFamily: F.display, color: C.accent, mr: ".75rem", fontSize: "1rem", flexShrink: 0 }}
          >
            {num}
          </Box>
        )}
        {title}
        <Box
          component="span"
          aria-hidden="true"
          sx={{
            width: 28,
            height: 28,
            borderRadius: "50%",
            border: active ? `1.5px solid ${C.accent}` : `1.5px solid ${C.border}`,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            transition: `all ${trans}`,
            color: active ? "#fff" : C.textMuted,
            background: active ? C.accent : "transparent",
            fontSize: ".85rem",
            fontWeight: 300,
            lineHeight: 1,
            transform: active ? "rotate(45deg)" : "none",
            "&::before": { content: '"+"' },
          }}
        />
      </Box>
      <Box
        role="region"
        sx={{
          maxHeight: active ? "500px" : 0,
          overflow: "hidden",
          transition: "max-height .35s ease",
          fontSize: ".87rem",
          color: C.textMuted,
          lineHeight: 1.75,
          px: { xs: "1.1rem", md: "1.5rem" },
          pb: active ? { xs: "1.1rem", md: "1.5rem" } : 0,
        }}
      >
        {content}
      </Box>
    </Box>
  );
};

export default Accordion;
